<template>
  <div class="">
    <b-navbar toggleable="sm" type="dark" variant="dark">
      <b-navbar-nav>
        <b-nav-item class="mr-auto">
          <a
            href="https://www.facebook.com/DropsXR"
            target="_blank"
          ><font-awesome-icon
            class="font-awesome-icon"
            :icon="['fab', 'facebook']"
          />
          </a>
          <a href="http://twitter.com/dropsAR" target="_blank">
            <font-awesome-icon
              class="font-awesome-icon"
              :icon="['fab', 'twitter']"
            />
          </a>
          <a href="http://instagram.com/dropsAR" target="_blank">
            <font-awesome-icon
              class="font-awesome-icon"
              :icon="['fab', 'instagram']"
            />
          </a>
          <a
            v-b-modal.modal-1
            class="align-right"
            variant="light"
          >
            Subscribe
          </a>
          <!-- <a
            data-mode="no_text"
            href="https://angel.co/audiodrops?follow=1&type=Startup&id=864632"
            target="_blank"
          >
            <font-awesome-icon
              class="font-awesome-icon"
              :icon="['fab', 'angellist']"
            />
          </a>
          <a href="http://medium.com/@DropsAR" target="_blank">
            <font-awesome-icon
              class="font-awesome-icon"
              :icon="['fab', 'medium']"
            />
          </a> -->
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="justify-content-end">
          Brooklyn ❤️ © Drops {{ new Date().getFullYear() }}
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
export default {}
</script>

<style scoped></style>
